import i18n from '@/i18n'
import { TAB_CATEGORY } from '@/constant/permission'
import BlankLayout from '../layout/blankLayout.vue'
import ManagementLayout from '../layout/managementLayout.vue'
import ReferralEditor from '../../admin/job/referralEditor/index.vue'
import ReferralLeaderboard from './leaderboard/index.vue'

export default {
  name: 'referralManagementLayout',
  path: '/referral/status-referral-management/',
  component: ManagementLayout,
  meta: {
    oldPageRoute: true,
    permission: TAB_CATEGORY.REFERRAL,
    titleI18n: 'admin.referral.title',
    breadcrumb: { hidden: true },
    tab: {
      get label () {
        return i18n.t('admin.referral.tab')
      }
    }
  },
  children: [
    {
      path: '/referral/status-referral-management/',
      component: BlankLayout,
      meta: {
        oldPageRoute: true,
        menu: {
          get label () {
            return i18n.t('admin.referral.menu.referralStatus')
          }
        }
      },
      children: [
        {
          name: 'jobReferralEditor',
          path: '/v-admin/job/:jobId/referral',
          component: ReferralEditor,
          meta: {
            isInclude: true,
            titleI18nKey: 'admin.job.referral.title',
            oldPageAdapterClass: 'job-referral-page'
          }
        }
      ]
    },
    {
      name: 'referralLeaderboard',
      path: '/v-admin/referral/referral-leaderboard/',
      component: ReferralLeaderboard,
      meta: {
        isNewPage: true,
        isInclude: true,
        titleI18nKey: 'admin.referral.leaderboard.title',
        menu: {
          get label () {
            return i18n.t('admin.referral.menu.companyReferrers')
          }
        }
      }
    },
    {
      path: '/referral/point-record/',
      component: BlankLayout,
      meta: {
        oldPageRoute: true,
        menu: {
          get label () {
            return i18n.t('admin.referral.menu.pointsRecord')
          }
        }
      }
    }
  ]
}
